var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconIndividualCustomer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0889 5C10.1866 5 8.64449 6.54213 8.64449 8.44444C8.64449 10.3468 10.1866 11.8889 12.0889 11.8889C13.9913 11.8889 15.5334 10.3468 15.5334 8.44444C15.5334 6.54213 13.9913 5 12.0889 5ZM12.0889 6.2002C13.3285 6.2002 14.3333 7.20507 14.3333 8.44464C14.3333 9.68421 13.3285 10.6891 12.0889 10.6891C10.8493 10.6891 9.84444 9.68421 9.84444 8.44464C9.84444 7.20507 10.8493 6.2002 12.0889 6.2002ZM18.3739 16.8108C18.2868 14.986 16.7797 13.5332 14.9334 13.5332H9.24449L9.07761 13.5372C7.2528 13.6242 5.80005 15.1313 5.80005 16.9776V18.3999L5.80553 18.4813C5.84526 18.7741 6.09629 18.9999 6.40005 18.9999C6.73142 18.9999 7.00005 18.7312 7.00005 18.3999V16.9776L7.00415 16.8409C7.07481 15.665 8.05083 14.7332 9.24449 14.7332H14.9334L15.0701 14.7373C16.246 14.808 17.1778 15.784 17.1778 16.9776V18.3999L17.1833 18.4813C17.223 18.7741 17.4741 18.9999 17.7778 18.9999C18.1092 18.9999 18.3778 18.7312 18.3778 18.3999V16.9776L18.3739 16.8108Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIndividualCustomer);
export default __webpack_public_path__ + "static/media/icon-individual-customer.bbd7c7a66404d65050dd603cf7f7cccd.svg";
export { ForwardRef as ReactComponent };